export default "__VITE_ASSET__DSH9cGgN__"